const itemTypePairs = [['risk', 'risk_control']];

export const isOnlyReadTrace = (upstreamItemTypeName: string, downtreamItemTypeName: string): boolean => {
  return itemTypePairs.some(
    ([upstream, downstream]) => upstream === upstreamItemTypeName && downstream === downtreamItemTypeName,
  );
};
